<template>
	<form class="w-full">
		<div class="w-full">
			<div
				v-if="1 === 2"
				class="form-group"
			>
				<label>Tipo</label>
				<br />
				<div class="form-group">
					<div
						class="btn-group-checkbox d-inline-block mt-4 mb-3 my-md-0"
					>
						<label for="fisica">
							<input
								type="radio"
								id="fisica"
								:value="1"
								v-model="form.account_type"
							/>
							<div class="btn btn-light-primary btn-sm">
								Fisica
							</div>
						</label>
						<label for="juridica">
							<input
								type="radio"
								id="juridica"
								:value="2"
								v-model="form.account_type"
							/>
							<div class="btn btn-light-primary btn-sm">
								Juridica
							</div>
						</label>
					</div>
				</div>
			</div>
		</div>
		<transition
			name="fast-fade"
			mode="out-in"
		>
			<div
				v-if="form.account_type == 2"
				key="1"
				class="w-full flex flex-col items-center"
			>
				<div class="w-full flex items-center gap-3">
					<div class="w-full md:w-6/12">
						<div class="form-group">
							<label>Nome Fantasia</label>
							<input
								ref="name"
								v-model="$v.form.name.$model"
								type="text"
								class="form-control"
								:class="{ 'is-invalid': $v.form.name.$error }"
							/>
							<div class="invalid-feedback">Obrigatório</div>
						</div>
					</div>
					<div class="w-full md:w-6/12">
						<div class="form-group">
							<label>Razão Social</label>
							<input
								v-model="form.social_name"
								type="text"
								class="form-control"
							/>
						</div>
					</div>
				</div>

				<div class="w-full flex items-center gap-3">
					<div class="w-full md:w-4/12">
						<div class="form-group">
							<label>CNPJ</label>
							<input
								type="tel"
								class="form-control"
								v-model="form.document_number"
								v-mask="['##.###.###/####-##']"
								:disabled="organization"
								ref="document_number"
							/>
							<div class="invalid-feedback">CNPJ Invalido</div>
						</div>
					</div>
					<div class="w-full md:w-4/12">
						<div class="form-group">
							<label>Inscr. Municipal</label>
							<input
								type="text"
								class="form-control"
								placeholder="isento"
								v-model="form.municipal_registration"
							/>
						</div>
					</div>
					<div class="w-full md:w-4/12">
						<div class="form-group">
							<label>Inscr. Estadual</label>
							<input
								v-model="form.state_registration"
								type="text"
								class="form-control"
								placeholder="isento"
							/>
						</div>
					</div>
				</div>
			</div>

			<div
				v-if="form.account_type === 1"
				key="2"
				class="w-full flex items-center gap-3"
			>
				<div class="w-full md:w-8/12">
					<div class="form-group">
						<label>Nome</label>
						<input
							ref="name"
							v-model="form.name"
							type="text"
							class="form-control"
						/>
						<div class="invalid-feedback">Obrigatório</div>
					</div>
				</div>
				<div class="w-full md:w-4/12">
					<div class="form-group">
						<label>CPF</label>
						<input
							ref="document_number"
							v-model="$v.form.document_number.$model"
							v-mask="['###.###.###-##']"
							type="tel"
							class="form-control"
							:class="{
								'is-invalid': $v.form.document_number.$error,
							}"
							:disabled="organization"
						/>
						<div class="invalid-feedback">CPF Invalido</div>
					</div>
				</div>
			</div>
		</transition>
		<div class="w-full flex items-center gap-3">
			<div class="w-full md:w-3/12">
				<div class="form-group">
					<label>CEP</label>
					<input
						ref="zipcode"
						v-model="form.zipcode"
						v-mask="['#####-###']"
						type="tel"
						class="form-control"
						@keyup.enter="SearchZipCode()"
						@blur="SearchZipCode()"
					/>
					<div class="invalid-feedback">Obrigatório</div>
				</div>
			</div>
			<div class="w-full md:w-6/12 lg:w-7/12">
				<div class="form-group">
					<label>Logradouro</label>
					<input
						ref="address"
						v-model="form.address"
						type="text"
						class="form-control"
					/>
					<div class="invalid-feedback">Obrigatório</div>
				</div>
			</div>
			<div class="w-full md:w-3/12 lg:w-2/12">
				<div class="form-group">
					<label>Numero</label>
					<input
						ref="number"
						v-model="form.number"
						type="number"
						class="form-control"
					/>
					<div class="invalid-feedback">Obrigatório</div>
				</div>
			</div>
		</div>

		<div class="w-full flex items-center gap-3">
			<div class="w-full md:w-6/12">
				<div class="form-group">
					<label>Complemento</label>
					<input
						v-model="form.complement"
						type="text"
						class="form-control"
					/>
				</div>
			</div>
			<div class="w-full md:w-6/12">
				<div class="form-group">
					<label>Bairro</label>
					<input
						ref="district"
						v-model="form.district"
						type="text"
						class="form-control"
					/>
					<div class="invalid-feedback">Obrigatório</div>
				</div>
			</div>
		</div>

		<div class="w-full flex items-center gap-3">
			<div class="w-full md:w-8/12">
				<div class="form-group">
					<label>Cidade</label>
					<input
						ref="city"
						v-model="form.city"
						type="text"
						class="form-control"
					/>
					<div class="invalid-feedback">Obrigatório</div>
				</div>
			</div>
			<div class="w-full md:w-4/12">
				<div class="form-group">
					<label>Estado</label>
					<select
						ref="state"
						v-model="form.state"
						type="text"
						class="form-control"
					>
						<option value="">Selecione...</option>
						<option
							v-for="state in states"
							:key="state.initials"
							:value="state.initials"
						>
							{{ state.name }}
						</option>
					</select>
					<div class="invalid-feedback">Obrigatório</div>
				</div>
			</div>
		</div>

		<div class="w-full flex items-center gap-3">
			<div class="w-full md:w-4/12">
				<div class="form-group">
					<label>Email</label>
					<input
						ref="email"
						v-model="form.email"
						type="email"
						class="form-control"
					/>
					<div class="invalid-feedback">Obrigatório</div>
				</div>
			</div>
			<div class="w-full md:w-4/12">
				<div class="form-group">
					<label>Telefone</label>
					<input
						ref="phone_1"
						v-model="$v.form.phone_1.$model"
						v-mask="['(##) ####-####', '(##) #####-####']"
						type="tel"
						class="form-control"
						:class="{ 'is-invalid': $v.form.phone_1.$error }"
					/>
					<div
						v-if="!$v.form.phone_1.required"
						class="invalid-feedback"
					>
						Obrigatório
					</div>
					<div
						v-else-if="!$v.form.phone_1.minLength"
						class="invalid-feedback"
					>
						Número inválido
					</div>
				</div>
			</div>
			<div class="w-full md:w-4/12">
				<div class="form-group">
					<label>Telefone 2</label>
					<input
						v-model="form.phone_2"
						v-mask="['(##) ####-####', '(##) #####-####']"
						type="tel"
						class="form-control"
					/>
				</div>
			</div>

			<FormGroup
				v-model="form.cnes"
				class="w-full md:w-4/12"
				label="CNES"
				formatter="numbers"
				:max-length="7"
				placeholder="CNES"
				:required="true"
				:input-classes="[{ 'field-error': !form.cnes || form.cnes.replace(/\D/g, '').length < 7 }]"
			>
				<template #tooltip>
					<ul class="info-modal-list">
						<li
							v-for="(info, idx) in GetInfoList(
								'CNES'
							)"
							:key="idx"
							class="info-modal-item"
						>
							{{ info }}
						</li>
					</ul>
				</template>
			</FormGroup>
		</div>
	</form>
</template>

<script>
	import Helpers from '../../../helpers'
	const helpers = new Helpers()
	const _ = require('lodash')

	import {
		required,
		minLength,
		sameAs,
		requiredIf,
	} from 'vuelidate/lib/validators'

	import { ORGANIZATION_INFOS } from '@/constants/OrganizationInfos'

	const ValidateDocument = (value, vm) => {
		if (value) {
			switch (vm.account_type) {
				case 2:
					return helpers.ValidaCNPJ(value)

				case 1:
					return helpers.ValidaCPF(value)
			}
		}

		return true
	}

	const ValidateCnesMinLength = value => {
		const digits = (value || '').replace(/\D/g, '')
		return digits.length === 0 || digits.length >= 7
	}

	import Swal from 'sweetalert2'
	export default {
		name: 'OrganizationForm',
		props: {
			organization_id: {
				type: [Number, String],
				default: null,
			},
			organization: {
				type: Object,
				default: null,
				required: false,
			},
			is_registered: {
				type: Boolean,
				default: false,
			},
			is_trial: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				form: {
					account_type: 2, // 1 - CPF OU 2 - CNPJ
					name: '',
					social_name: '',
					document_number: '',
					state_registration: '',
					municipal_registration: '',
					address: '',
					number: '',
					district: '',
					complement: '',
					city: '',
					state: '',
					zipcode: '',
					email: '',
					phone_1: '',
					phone_2: '',
					cnes: '',
				},
				states: window.statesBR,
				infos: {},
				infoModal: {
					show: false,
					type: null,
					direction: 'down',
				},
			}
		},
		validations() {
			let obj = {
				form: {
					name: {
						required,
					},
					document_number: {
						ValidateDocument,
					},
					phone_1: {
						required: requiredIf(() => {
							return this.organization?.instances[0]?.config
								.messages
						}),
						minLength: minLength(14),
					},
					cnes: {
						required,
						minLength: ValidateCnesMinLength,
					}
				},
			}

			return obj
		},
		watch: {
			organization_id: {
				immediate: true,
				handler(val) {
					if (val) {
						this.form.id = val
					}
				},
			},
			organization: {
				immediate: true,
				handler(val) {
					if (!_.isEmpty(val)) {
						this.form.account_type = val.account_type
						this.form.name = val.name
						this.form.social_name = val.social_name
						this.form.document_number = val.document_number
						this.form.state_registration = val.state_registration
						this.form.municipal_registration =
							val.municipal_registration
						this.form.address = val.address
						this.form.number = val.number
						this.form.district = val.district
						this.form.complement = val.complement
						this.form.city = val.city
						this.form.state = val.state
						this.form.zipcode = val.zipcode
						this.form.email = val.email
						this.form.phone_1 = val.phone_1
						this.form.phone_2 = val.phone_2
						this.form.cnes = val.cnes
					}
				},
				deep: true,
			},
			'form.account_type': {
				handler(val) {
					this.form.social_name = ''
					this.form.document_number = ''
					this.form.state_registration = ''
					this.form.municipal_registration = ''
				},
			},
		},
		methods: {
			async Validate() {
				this.$v.form.$touch()

				if (!this.$v.form.$invalid) {
					this.$emit('submit', this.form)
					this.$emit('next')
				} else {
					window.helpers.focusInvalid(this.$v.form, this)
				}
			},
			async SaveCostumer(form) {
				const vm = this

				if (!vm.is_registered) {
					vm.$parent.StartLoading()

					const organization = form

					const phones = vm.ParsePhone(form.phone_1)

					const customer = {
						name: organization.name,
						email: organization.email,
						registry_code: organization.document_number,
						phone: phones,
						address: {
							street: organization.address,
							number: organization.number,
							additional_details: organization.complement
								? organization.complement
								: 'nenhum',
							zipcode: organization.zipcode,
							neighborhood: organization.district,
							city: organization.city,
							state: organization.state,
						},
					}

					return await window.api
						.call('post', '/gateway/store-customer', {
							organization_id: parseInt(vm.organization_id),
							customer,
						})
						.then(async ({ data }) => {
							if (!data.response) {
								Swal.fire({
									title: 'Ops...',
									text: 'Erro ao completar o cadastro no gateway de pagamentos!',
									icon: 'error',
								})

								return
							}
						})
						.finally(() => {
							vm.$parent.FinishLoading()
						})
				}
			},
			async SearchZipCode() {
				const vm = this
				const zipcode = this.$v.form.zipcode.$model

				if (zipcode) {
					if (zipcode.length == 9) {
						vm.$parent.StartLoading()

						helpers
							.searchZipCode(zipcode)
							.then(res => {
								vm.form.address = res.address
								vm.form.district = res.district
								vm.form.complement = res.complement
								vm.form.city = res.city
								vm.form.state = res.state
							})
							.finally(() => {
								vm.$parent.FinishLoading()
							})
					}
				}
			},
			ParsePhone(phone) {
				if (phone) {
					let new_phone = phone
					new_phone = new_phone.replace('(', '')
					new_phone = new_phone.replace(')', '')
					new_phone = new_phone.replace(' ', '')
					new_phone = new_phone.replace('-', '')

					return '55' + new_phone
				}
				return ''
			},
			Preencher() {
				const vm = this.form

				vm.account_type = 2
				vm.name = 'Org teste'
				vm.document_number = '82.774.715/0001-66'
				vm.address = ''
				vm.number = '205'
				vm.district = ''
				vm.complement = 'nenhum'
				vm.city = ''
				vm.state = ''
				vm.zipcode = '15056710'
				vm.email = 'danilo.sanches@visualsystems.com.br'
				vm.phone_1 = '14991093231'
				vm.phone_2 = ''
				vm.cnes = '9999999'
			},
			OpenInfoModal(type, event) {
				if (this.infoModal.show && this.infoModal.type === type) {
					this.CloseInfoModal()
					return
				}
				document.removeEventListener('click', this.OnDocumentClick)
				const btn = event?.currentTarget
				const rect = btn ? btn.getBoundingClientRect() : null
				const spaceBelow = rect ? window.innerHeight - rect.bottom : 999
				this.infoModal.direction = spaceBelow < 520 ? 'up' : 'down'
				this.infoModal.type = type
				this.infoModal.show = true
				setTimeout(() => {
					document.addEventListener('click', this.OnDocumentClick)
				}, 0)
			},
			OnDocumentClick() {
				this.CloseInfoModal()
			},
			CloseInfoModal() {
				document.removeEventListener('click', this.OnDocumentClick)
				this.infoModal.show = false
				this.infoModal.type = null
			},
			GetInfoList(type) {
				const infoType = type || this.infoModal.type
				if (!infoType) return []
				return ORGANIZATION_INFOS[infoType] || []
			},
		},
	}
</script>

<style lang="scss" scoped>
	.field-label {
		display: flex;
		align-items: center;
		padding: 0;
	}

	.info-button {
		padding: 0;
		border: none;
		background-color: transparent;
		cursor: pointer;

		i {
			font-size: 1.25rem;
			margin-top: 0.3rem;
			color: var(--fontInfoActive);
		}

		&:hover {
			i {
				color: var(--fontColorHover);
			}
		}

		&:disabled {
			cursor: default;

			i {
				color: var(--fontInfoInactive);
			}
		}
	}

	.info-anchor {
		position: relative;
		display: inline-flex;
		align-items: center;
	}

	.info-inline-popup {
		position: absolute;
		z-index: 200;
		top: calc(100% + 4px);
		left: 0;
		background-color: var(--tippyBackgroundColor);
		border: 1px solid var(--tippyBorderColor);
		border-radius: 0.5rem;
		padding: 0.75rem;
		width: 380px;
		max-width: calc(100vw - 16px);
		box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
			0 10px 10px -5px rgba(0, 0, 0, 0.04);
		white-space: normal;

		&.info-inline-popup--up {
			top: auto;
			bottom: calc(100% + 4px);
		}
	}

	.info-modal-list {
		margin: 0;
		padding: 0;
		list-style: none;
	}

	.info-modal-item {
		padding-top: 0.25rem;
		padding-bottom: 0.25rem;
		color: var(--fontColor);
	}
</style>
